// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureItem_container__6KZLB","iconWrapper":"FeatureItem_iconWrapper__LjXbv","textWrapper":"FeatureItem_textWrapper__oOxH2","title":"FeatureItem_title__E31d_"};